import { Link } from "react-router-dom";
import { AppStoreButton, PlayStoreButton } from "./StoreButtons";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="bg-neutral-950 text-white pt-24 lg:pt-32 pb-10 px-6 lg:px-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 mb-20">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_lift-minimal/artifacts/j1888ons_Logo%20-%20Lift%20AI.jpg"
                alt="Lift AI"
                className="w-9 h-9 rounded-lg object-cover"
              />
              <span className="text-xl font-semibold tracking-tight">
                Lift AI
              </span>
            </div>
            <p className="text-neutral-400 text-base leading-relaxed max-w-sm">
              Une IA dédiée à ton physique. Analyse, feedback, et programme
              personnalisé — dans la poche.
            </p>

            <div className="flex flex-wrap gap-3 mt-8">
              <AppStoreButton variant="light" testId="footer-app-store" />
              <PlayStoreButton variant="light" testId="footer-play-store" />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 md:justify-self-end md:text-right">
            <div>
              <p className="text-xs uppercase tracking-wider text-neutral-500 mb-4">
                Légal
              </p>
              <ul className="flex flex-col gap-3">
                <li>
                  <Link
                    to="/politique-de-confidentialite"
                    data-testid="footer-link-privacy"
                    className="text-sm text-neutral-300 hover:text-violet-400 transition-colors"
                  >
                    Politique de confidentialité
                  </Link>
                </li>
                <li>
                  <Link
                    to="/conditions-utilisation"
                    data-testid="footer-link-terms"
                    className="text-sm text-neutral-300 hover:text-violet-400 transition-colors"
                  >
                    Conditions d'utilisation
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <p className="text-xs uppercase tracking-wider text-neutral-500 mb-4">
                Contact
              </p>
              <ul className="flex flex-col gap-3">
                <li>
                  <Link
                    to="/#support"
                    data-testid="footer-link-support"
                    className="text-sm text-neutral-300 hover:text-violet-400 transition-colors"
                  >
                    Support
                  </Link>
                </li>
                <li>
                  <a
                    href="mailto:contact@liftai.fr"
                    data-testid="footer-link-email"
                    className="text-sm text-neutral-300 hover:text-violet-400 transition-colors"
                  >
                    contact@liftai.fr
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Giant brand text */}
        <div
          aria-hidden="true"
          data-testid="footer-brand-text"
          className="select-none leading-none mb-10"
        >
          <p className="text-[18vw] md:text-[14vw] font-black tracking-tighter bg-gradient-to-b from-white via-white to-neutral-950 bg-clip-text text-transparent leading-[0.85]">
            LIFT AI
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 pt-8 border-t border-neutral-800">
          <p className="text-sm text-neutral-500">
            © {year} Lift AI. Tous droits réservés.
          </p>
          <p className="text-sm text-neutral-500">
            Conçu avec précision.
          </p>
        </div>
      </div>
    </footer>
  );
}
